import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0bfc3171 = () => interopDefault(import('../../../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _71ad05c0 = () => interopDefault(import('../../../pages/feellogs/index.vue' /* webpackChunkName: "pages/feellogs/index" */))
const _6d6dfa18 = () => interopDefault(import('../../../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _60933156 = () => interopDefault(import('../../../pages/account/ChangePassword.vue' /* webpackChunkName: "pages/account/ChangePassword" */))
const _6b41505e = () => interopDefault(import('../../../pages/account/FindPassword.vue' /* webpackChunkName: "pages/account/FindPassword" */))
const _49680ee0 = () => interopDefault(import('../../../pages/account/ResetPassword.vue' /* webpackChunkName: "pages/account/ResetPassword" */))
const _d42dd4bc = () => interopDefault(import('../../../pages/account/SignUp.vue' /* webpackChunkName: "pages/account/SignUp" */))
const _2f274621 = () => interopDefault(import('../../../pages/mobile/MobileCharacters.vue' /* webpackChunkName: "pages/mobile/MobileCharacters" */))
const _d93f3be8 = () => interopDefault(import('../../../pages/mobile/MobileEditMyProfile.vue' /* webpackChunkName: "pages/mobile/MobileEditMyProfile" */))
const _d184d330 = () => interopDefault(import('../../../pages/mobile/MobileFeellogDetail.vue' /* webpackChunkName: "pages/mobile/MobileFeellogDetail" */))
const _9839db68 = () => interopDefault(import('../../../pages/mobile/MobileFeellogs.vue' /* webpackChunkName: "pages/mobile/MobileFeellogs" */))
const _08954db2 = () => interopDefault(import('../../../pages/mobile/MobileFreeCharacterDetail.vue' /* webpackChunkName: "pages/mobile/MobileFreeCharacterDetail" */))
const _3ce22f14 = () => interopDefault(import('../../../pages/mobile/MobileMyProfile.vue' /* webpackChunkName: "pages/mobile/MobileMyProfile" */))
const _e1ff6c36 = () => interopDefault(import('../../../pages/mobile/MobilePaymentHistory.vue' /* webpackChunkName: "pages/mobile/MobilePaymentHistory" */))
const _556df4b8 = () => interopDefault(import('../../../pages/mobile/MobileProCharacterDetail.vue' /* webpackChunkName: "pages/mobile/MobileProCharacterDetail" */))
const _03ab68da = () => interopDefault(import('../../../pages/order/CancelPayment.vue' /* webpackChunkName: "pages/order/CancelPayment" */))
const _164b2abb = () => interopDefault(import('../../../pages/order/FailturePayment.vue' /* webpackChunkName: "pages/order/FailturePayment" */))
const _0be376d0 = () => interopDefault(import('../../../pages/order/PendingPayment.vue' /* webpackChunkName: "pages/order/PendingPayment" */))
const _76a4daa8 = () => interopDefault(import('../../../pages/order/SuccessPayment.vue' /* webpackChunkName: "pages/order/SuccessPayment" */))
const _8be61c50 = () => interopDefault(import('../../../pages/profile/edit.vue' /* webpackChunkName: "pages/profile/edit" */))
const _6407384c = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _6321172c = () => interopDefault(import('../../../pages/character/_slug.vue' /* webpackChunkName: "pages/character/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/checkout",
    component: _0bfc3171,
    name: "checkout"
  }, {
    path: "/feellogs",
    component: _71ad05c0,
    name: "feellogs"
  }, {
    path: "/profile",
    component: _6d6dfa18,
    name: "profile"
  }, {
    path: "/account/ChangePassword",
    component: _60933156,
    name: "account-ChangePassword"
  }, {
    path: "/account/FindPassword",
    component: _6b41505e,
    name: "account-FindPassword"
  }, {
    path: "/account/ResetPassword",
    component: _49680ee0,
    name: "account-ResetPassword"
  }, {
    path: "/account/SignUp",
    component: _d42dd4bc,
    name: "account-SignUp"
  }, {
    path: "/mobile/MobileCharacters",
    component: _2f274621,
    name: "mobile-MobileCharacters"
  }, {
    path: "/mobile/MobileEditMyProfile",
    component: _d93f3be8,
    name: "mobile-MobileEditMyProfile"
  }, {
    path: "/mobile/MobileFeellogDetail",
    component: _d184d330,
    name: "mobile-MobileFeellogDetail"
  }, {
    path: "/mobile/MobileFeellogs",
    component: _9839db68,
    name: "mobile-MobileFeellogs"
  }, {
    path: "/mobile/MobileFreeCharacterDetail",
    component: _08954db2,
    name: "mobile-MobileFreeCharacterDetail"
  }, {
    path: "/mobile/MobileMyProfile",
    component: _3ce22f14,
    name: "mobile-MobileMyProfile"
  }, {
    path: "/mobile/MobilePaymentHistory",
    component: _e1ff6c36,
    name: "mobile-MobilePaymentHistory"
  }, {
    path: "/mobile/MobileProCharacterDetail",
    component: _556df4b8,
    name: "mobile-MobileProCharacterDetail"
  }, {
    path: "/order/CancelPayment",
    component: _03ab68da,
    name: "order-CancelPayment"
  }, {
    path: "/order/FailturePayment",
    component: _164b2abb,
    name: "order-FailturePayment"
  }, {
    path: "/order/PendingPayment",
    component: _0be376d0,
    name: "order-PendingPayment"
  }, {
    path: "/order/SuccessPayment",
    component: _76a4daa8,
    name: "order-SuccessPayment"
  }, {
    path: "/profile/edit",
    component: _8be61c50,
    name: "profile-edit"
  }, {
    path: "/",
    component: _6407384c,
    name: "index"
  }, {
    path: "/character/:slug?",
    component: _6321172c,
    name: "character-slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
